import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Person4Icon from '@mui/icons-material/Person4';
import Logo from '../src/components/pages/Logo/A R Logo copy.jpg';
import PersonIcon from "@mui/icons-material/Person";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';

const LoginForm = () => {
    const history = useHistory();
    const { isAuthenticated, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    // const [companyId, setCompanyId] = useState('');
    //const [branchId, setBranchId] = useState('');
    const location = useLocation();

    const branchId = 1;
    const companyId = 1;

    useEffect(() => {
        setIsAnimating(true);
    }, []);



    const handleLogin = async () => {
        try {

            const jwtToken = await performLogin();
            const responseData = jwtDecode(jwtToken);
            const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
            const permissions = Object.keys(responseData).filter(
                (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
            );

            let isSuper = false;
            if (responseData.isSuperAdmin.toLowerCase() === "true") {
                isSuper = true;
            }

            if (isSuper == false) {
                const parsedCompanyId = parseInt(responseData.companyId, 10);

                if (parsedCompanyId === companyId) {
                    login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                    const redirectParam = new URLSearchParams(location.search).get("redirect");
                    const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                    history.replace(redirectPath);
                }
                else {
                    toast.error('Invalid User !', {
                        position: "top-center",
                    });
                }
            }
            else {
                login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, responseData.CompanyName, permissions, jwtToken, responseData.roleName, responseData.branchstate, responseData.username);
                const redirectParam = new URLSearchParams(location.search).get("redirect");
                const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
                history.replace(redirectPath);
            }


        } catch (error) {
            toast.error('Login failed', {
                position: "top-center",
            });
        }
    };

    const performLogin = async () => {
        const loginData = {
            UserName: username,
            Password: password,
            CompanyId: companyId,
            BranchId: branchId
        };

        const response = await postLogin('LoginApi', loginData);

        if (response.responseCode === '1111') {
            const jwtToken = response.response_data.token;

            return jwtToken;
        } else {
            throw new Error(response.Message);
        }
    };


    if (isAuthenticated) {
        return <App />;
    }

    // return (
    //     <div
    //         style={{
    //             display: "flex",
    //             justifyContent: "center",
    //             alignItems: "center",
    //             minHeight: "100vh",
    //             backgroundImage: "url('https://source.unsplash.com/1600x900/?technology,abstract')",
    //             backgroundSize: "cover",
    //             backgroundPosition: "center",
    //             backdropFilter: "blur(4px)",
    //             padding: "20px",
    //         }}
    //     >
    //         <ToastContainer position="top-center" autoClose={3000} />

    //         <div
    //             style={{
    //                 width: "100%",
    //                 maxWidth: "420px",
    //                 padding: "40px 30px",
    //                 borderRadius: "12px",
    //                 background: "rgba(44, 47, 72, 0.9)",
    //                 boxShadow: "0 12px 30px rgba(0,0,0,0.4)",
    //                 textAlign: "center",
    //                 backdropFilter: "blur(8px)",
    //             }}
    //         >

    //             <h5 style={{ color: "#fff", marginBottom: "10px" }}>
    //                 Welcome Back
    //             </h5>
    //             <p style={{ color: "#ccc", marginBottom: "30px" }}>
    //                 Login to your account
    //             </p>

    //             <form
    //                 onSubmit={(e) => {
    //                     e.preventDefault();
    //                     handleLogin();
    //                 }}
    //             >

    //                 <div style={{ position: "relative", marginBottom: "1.5rem" }}>
    //                     <span
    //                         style={{
    //                             position: "absolute",
    //                             left: "12px",
    //                             top: "50%",
    //                             transform: "translateY(-50%)",
    //                             color: "#aaa",
    //                         }}
    //                     >
    //                         <Person4Icon />
    //                     </span>

    //                     <input
    //                         type="text"
    //                         placeholder="Username"
    //                         value={username}
    //                         onChange={(e) => setUsername(e.target.value)}
    //                         style={{
    //                             width: "100%",
    //                             padding: "12px 12px 12px 40px",
    //                             borderRadius: "8px",
    //                             border: "1px solid #555",
    //                             background: "#2C2C3C",
    //                             color: "#fff",
    //                             outline: "none",
    //                             transition: "all 0.3s ease",
    //                         }}
    //                     />
    //                 </div>


    //                 <div style={{ position: "relative", marginBottom: "1.8rem" }}>
    //                     <span
    //                         style={{
    //                             position: "absolute",
    //                             left: "12px",
    //                             top: "50%",
    //                             transform: "translateY(-50%)",
    //                             color: "#aaa",
    //                             cursor: "pointer",
    //                         }}
    //                         onClick={() => setShowPassword((prev) => !prev)}
    //                     >
    //                         {showPassword ? <LockOpenIcon /> : <LockIcon />}
    //                     </span>
    //                     <input
    //                         type={showPassword ? "text" : "password"}
    //                         placeholder="Password"
    //                         value={password}
    //                         onChange={(e) => setPassword(e.target.value)}
    //                         style={{
    //                             width: "100%",
    //                             padding: "12px 12px 12px 40px",
    //                             borderRadius: "8px",
    //                             border: "1px solid #555",
    //                             background: "#2C2C3C",
    //                             color: "#fff",
    //                             outline: "none",
    //                             transition: "all 0.3s ease",
    //                         }}
    //                     />
    //                 </div>

    //                 <button
    //                     type="submit"
    //                     style={{
    //                         width: "100%",
    //                         padding: "12px",
    //                         borderRadius: "8px",
    //                         border: "none",
    //                         background: "#FF748B",
    //                         color: "#fff",
    //                         fontSize: "16px",
    //                         fontWeight: "600",
    //                         cursor: "pointer",
    //                         transition: "background 0.3s ease",
    //                     }}
    //                     onMouseOver={(e) => (e.target.style.background = "#ff5670")}
    //                     onMouseOut={(e) => (e.target.style.background = "#FF748B")}
    //                 >
    //                     Login
    //                 </button>
    //             </form>
    //         </div>
    //     </div>
    // );
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                background: "#0d2545",
                color: "#fff",
                fontFamily: "Arial, sans-serif",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    padding: "30px",
                    borderRadius: "12px",
                    background: "#1c3b6e",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
                    textAlign: "center",
                }}
            >
                < ScatterPlotIcon />
                <h4 style={{ marginBottom: "20px", color: "#fff", fontFamily: "cursive" }}>
                    {/* IRA-Suite™ */}
                    IRA-Lite
                </h4>
                <p style={{ marginBottom: "30px", color: "#d1d9e6" }}>
                    Login To Your Account
                </p>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleLogin();
                    }}
                >
                    {/* Username field with icon */}
                    <div style={{ position: "relative", marginBottom: "15px" }}>
                        <FaUser
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                            }}
                        />
                        <input
                            type="text"
                            placeholder="User Name"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px 10px 10px 40px",
                                borderRadius: "8px",
                                border: "1px solid #4c6793",
                                background: "#264a86",
                                color: "#fff",
                                outline: "none",
                            }}
                        />
                    </div>

                    {/* Password field with icon and visibility toggle */}
                    <div style={{ position: "relative", marginBottom: "15px" }}>
                        <FaLock
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                            }}
                        />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px 10px 10px 40px",
                                borderRadius: "8px",
                                border: "1px solid #4c6793",
                                background: "#264a86",
                                color: "#fff",
                                outline: "none",
                            }}
                        />
                        <div
                            onClick={() => setShowPassword((prev) => !prev)}
                            style={{
                                position: "absolute",
                                top: "50%",
                                right: "10px",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                                cursor: "pointer",
                            }}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </div>
                    </div>

                    <button
                        type="submit"
                        style={{
                            width: "100%",
                            padding: "10px",
                            marginTop: "15px",
                            borderRadius: "8px",
                            border: "1px solid #fff",
                            background: "transparent",
                            color: "#fff",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.background = "#fff";
                            e.target.style.color = "#000";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.background = "transparent";
                            e.target.style.color = "#fff";
                        }}
                    >
                        Login
                    </button>
                </form>

                {/* <button
                    style={{
                        width: "100%",
                        padding: "10px",
                        marginTop: "15px",
                        borderRadius: "8px",
                        border: "1px solid #fff",
                        background: "transparent",
                        color: "#fff",
                        fontWeight: "bold",
                        cursor: "pointer",
                    }}
                >
                    Property Binnits
                </button> */}
            </div>
        </div>
    );
};

export default LoginForm;
